import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import Tab from '../../../components/Tab';
import { transformDataColumns } from '../../../utils/transformDataColumns';

const header = defineMessages({
  title: {
    id: 'hubs.organizations-and-services.services.title',
    defaultMessage: 'Services Available',
  },
});

const messages = defineMessages({
  academicCareerCounseling: {
    id: 'hubs.organizations-and-services.services.academicCareerCounseling',
    defaultMessage: 'Academic Career Counseling',
  },
  accommodationsForStudentsWithADHD: {
    id: 'hubs.organizations-and-services.services.accommodationsForStudentsWithADHD',
    defaultMessage: 'Accommodations for Students With ADHD',
  },
  assistanceForHearingImpaired: {
    id: 'hubs.organizations-and-services.services.assistanceForHearingImpaired',
    defaultMessage: 'Assistance for HearingImpaired',
  },
  assistanceForMobilityImpaired: {
    id: 'hubs.organizations-and-services.services.assistanceForMobilityImpaired',
    defaultMessage: 'Assistance for Mobility Impaired',
  },
  assistanceForVisuallyImpaired: {
    id: 'hubs.organizations-and-services.services.assistanceForVisuallyImpaired',
    defaultMessage: 'Assistance for Visually Impaired',
  },
  bookOnTapeForRFBD: {
    id: 'hubs.organizations-and-services.services.bookOnTapeForRFBD',
    defaultMessage: 'Book on Tape for RFBD',
  },
  calculatorsAllowedInExams: {
    id: 'hubs.organizations-and-services.services.calculatorsAllowedInExams',
    defaultMessage: 'Calculators Allowed in Exams',
  },
  computersAllowedInExams: {
    id: 'hubs.organizations-and-services.services.computersAllowedInExams',
    defaultMessage: 'Computers Allowed in Exams',
  },
  dayCareServices: {
    id: 'hubs.organizations-and-services.services.dayCareServices',
    defaultMessage: 'Day Care Services',
  },
  dictionaryAllowedInExams: {
    id: 'hubs.organizations-and-services.services.dictionaryAllowedInExams',
    defaultMessage: 'Dictionary Allowed in Exams',
  },
  ESL: {
    id: 'hubs.organizations-and-services.services.ESL',
    defaultMessage: 'ESL (English as Second Language)',
  },
  healthServicesAvailable: {
    id: 'hubs.organizations-and-services.services.healthServicesAvailable',
    defaultMessage: 'Health Services Available',
  },
  internshipsWithPay: {
    id: 'hubs.organizations-and-services.services.internshipsWithPay',
    defaultMessage: 'Internships with Pay',
  },
  internshipsWithoutPay: {
    id: 'hubs.organizations-and-services.services.internshipsWithoutPay',
    defaultMessage: 'Internships without Pay',
  },
  jobPlacement: {
    id: 'hubs.organizations-and-services.services.jobPlacement',
    defaultMessage: 'Job Placement',
  },
  LDSpecialists: {
    id: 'hubs.organizations-and-services.services.LDSpecialists',
    defaultMessage: 'LD Specialists',
  },
  learningCenter: {
    id: 'hubs.organizations-and-services.services.learningCenter',
    defaultMessage: 'Learning Center',
  },
  libraryFacilities: {
    id: 'hubs.organizations-and-services.services.libraryFacilities',
    defaultMessage: 'Library Facilities',
  },
  peerTutors: {
    id: 'hubs.organizations-and-services.services.peerTutors',
    defaultMessage: 'Peer Tutors',
  },
  professionalTutors: {
    id: 'hubs.organizations-and-services.services.professionalTutors',
    defaultMessage: 'Professional Tutors',
  },
  readingMachine: {
    id: 'hubs.organizations-and-services.services.readingMachine',
    defaultMessage: 'Reading Machine',
  },
  remedialServices: {
    id: 'hubs.organizations-and-services.services.remedialServices',
    defaultMessage: 'Remedial Services',
  },
  spellcheckerAllowedInExam: {
    id: 'hubs.organizations-and-services.services.spellcheckerAllowedInExam',
    defaultMessage: 'Spellchecker Allowed in Exam',
  },
  studentEmployment: {
    id: 'hubs.organizations-and-services.services.studentEmployment',
    defaultMessage: 'Student Employment',
  },
  tapeRecordingInClass: {
    id: 'hubs.organizations-and-services.services.tapeRecordingInClass',
    defaultMessage: 'Tape Recording in Class',
  },
  tapingOfBooksNotFromRFBD: {
    id: 'hubs.organizations-and-services.services.tapingOfBooksNotFromRFBD',
    defaultMessage: 'Taping of Books not from RFBD',
  },
  veteran: {
    id: 'hubs.organizations-and-services.services.veteran',
    defaultMessage: 'Veteran',
  },
  aspergersAutismSupportServices: {
    id: 'hubs.organizations-and-services.services.aspergersAutismSupportServices',
    defaultMessage: 'Aspergers Autism Support Services',
  },
  counselingServices: {
    id: 'hubs.organizations-and-services.services.counselingServices',
    defaultMessage: 'Counseling Services',
  },
  learningDifferencesSupport: {
    id: 'hubs.organizations-and-services.services.learningDifferencesSupport',
    defaultMessage: 'Learning Differences Support',
  },
});

function Services({ intl, services }) {
  const [leftSide, rightSide] = transformDataColumns(messages, services, intl);

  return (
    <Tab.Pane>
      <h3>{intl.formatMessage(header.title)}</h3>
      <div className="row">
        <ul className="column">
          {leftSide.map(text => (
            <li key={text}>{text}</li>
          ))}
        </ul>
        <ul className="column">
          {rightSide.map(text => (
            <li key={text}>{text}</li>
          ))}
        </ul>
      </div>
    </Tab.Pane>
  );
}

Services.propTypes = {
  services: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(Services);
